module.exports = __webpack_public_path__ + "img/onepack-badge.64061264.svg";